module.exports = __webpack_public_path__ + "img/tag.0e7bc9fa.svg";